import React, { Component } from 'react';
import { Users, CheckCircle, Activity, Calendar as CalendarIcon, UserPlus, CalendarPlus } from 'lucide-react';
import './Dashboard.css';

class Dashboard extends Component {
    render() {
        const { currentUser, stats, onNewPatientClick, onNewAppointmentClick, hasPermission } = this.props;

        return (
            <div className="dashboard-container">
                <div className="welcome-section">
                    <h1>Welcome, {currentUser.name}!</h1>
                    <p>Here's a look at what's happening in your clinic today.</p>
                </div>
                <div className="stats-grid">
                    <div className="stat-card primary">
                        <div className="stat-icon"><Users size={32} /></div>
                        <div className="stat-info"><h3>{stats.totalPatients}</h3><p>Total Patients</p></div>
                    </div>
                    <div className="stat-card success">
                        <div className="stat-icon"><CheckCircle size={32} /></div>
                        <div className="stat-info"><h3>{stats.activePatients}</h3><p>Active Treatment</p></div>
                    </div>
                    <div className="stat-card warning">
                        <div className="stat-icon"><Activity size={32} /></div>
                        <div className="stat-info"><h3>{stats.followUpPatients}</h3><p>Follow-up Patients</p></div>
                    </div>
                    <div className="stat-card info">
                        <div className="stat-icon"><CalendarIcon size={32} /></div>
                        <div className="stat-info"><h3>{stats.todayAppointments}</h3><p>Today's Appointments</p></div>
                    </div>
                </div>
                <div className="quick-actions">
                    <h2>Quick Actions</h2>
                    <div className="action-buttons">
                        <button 
                            className="action-btn" 
                            onClick={onNewPatientClick} 
                            disabled={!hasPermission('addPatient')}
                        >
                            <UserPlus size={20} /> New Patient
                        </button>
                        <button 
                            className="action-btn" 
                            onClick={onNewAppointmentClick}
                            disabled={!hasPermission('manageAppointments')}
                        >
                            <CalendarPlus size={20} /> New Appointment
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

export default Dashboard;
